"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MobileNav = void 0;
var _react = _interopRequireDefault(require("react"));
var _Phone = _interopRequireDefault(require("@berlitz/streamline-icons/lib/bold/20-Phones-Mobile-Devices/01-Phone/Phone"));
var _getDistanceScrolled = _interopRequireDefault(require("@berlitz/max-utils/lib/getDistanceScrolled"));
var _bodyScrollLock = require("@berlitz/max-utils/lib/bodyScrollLock");
var _spacer = _interopRequireDefault(require("@berlitz/spacer"));
var _MobileNav = require("./MobileNav.style");
var _styledComponents = require("styled-components");
var _LanguageDropDown = _interopRequireDefault(require("./LanguageDropDown"));
var _MenuToggleButtonJs = _interopRequireDefault(require("./MenuToggleButtonJs"));
var _MenuNoJs = _interopRequireDefault(require("./MenuNoJs"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }
  return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
var dataKeyBase = 'max-mobile-nav';
var MobileNav = /*#__PURE__*/function (_React$Component) {
  _inherits(MobileNav, _React$Component);
  var _super = _createSuper(MobileNav);
  function MobileNav() {
    var _temp, _this;
    _classCallCheck(this, MobileNav);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return _possibleConstructorReturn(_this, (_temp = _this = _super.call.apply(_super, [this].concat(args)), _this.state = {
      open: false,
      jsEnabled: false,
      offset: 0
    }, _this.handleModalControl = function () {
      var currentOffset = !_this.state.open ? (0, _getDistanceScrolled.default)() : false;
      var toggleDuration = _this.props.theme.topNav.mobile.toggleDuration;
      _this.setState(function (_ref) {
        var open = _ref.open,
          offset = _ref.offset;
        return {
          open: !open,
          offset: currentOffset ? currentOffset : offset
        };
      }, function () {
        if (_this.state.open) {
          setTimeout(function () {
            return _this.setBodyStyleFixed();
          }, toggleDuration);
        } else {
          _this.setBodyStyleDefault();
          window.scrollTo(0, _this.state.offset);
        }
      });
    }, _temp));
  }
  _createClass(MobileNav, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setState({
        jsEnabled: true
      });
      if (this.state.open) {
        (0, _bodyScrollLock.addBodyScrollLock)();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      (0, _bodyScrollLock.removeBodyScrollLock)();
    }
  }, {
    key: "setBodyStyleDefault",
    value: function setBodyStyleDefault() {
      (0, _bodyScrollLock.removeBodyScrollLock)();
    }
  }, {
    key: "setBodyStyleFixed",
    value: function setBodyStyleFixed() {
      (0, _bodyScrollLock.addBodyScrollLock)();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        mobileLinks = _this$props.mobileLinks,
        mobileSecondaryLinks = _this$props.mobileSecondaryLinks,
        logo = _this$props.logo,
        telNumber = _this$props.telNumber,
        languageLinks = _this$props.languageLinks,
        activeLanguage = _this$props.activeLanguage,
        stickyNavCta = _this$props.stickyNavCta;
      var _this$state = this.state,
        open = _this$state.open,
        jsEnabled = _this$state.jsEnabled;
      var toggleButtonId = 'mobile-navigation';
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_MobileNav.Wrapper, {
        "data-key": "max-top-nav--mobile"
      }, /*#__PURE__*/_react.default.createElement(_MobileNav.ModalControl, {
        open: open
      }, /*#__PURE__*/_react.default.createElement(_MobileNav.LogoWrapper, {
        "data-key": "max-top-nav--mobile__logo"
      }, logo), /*#__PURE__*/_react.default.createElement(_MobileNav.Actions, null, stickyNavCta && stickyNavCta, telNumber && /*#__PURE__*/_react.default.createElement(_spacer.default, {
        size: "lg",
        left: true
      }, /*#__PURE__*/_react.default.createElement("a", {
        href: "tel:".concat(telNumber)
      }, /*#__PURE__*/_react.default.createElement(_Phone.default, {
        title: "Click to call"
      }))), /*#__PURE__*/_react.default.createElement(_spacer.default, {
        size: "xs",
        left: true
      }, jsEnabled ? /*#__PURE__*/_react.default.createElement(_MenuToggleButtonJs.default, {
        open: open,
        toggleButtonId: toggleButtonId,
        handleModalControl: this.handleModalControl.bind(this)
      }) : /*#__PURE__*/_react.default.createElement(_MenuNoJs.default, {
        toggleButtonId: toggleButtonId,
        dataKeyBase: dataKeyBase,
        languageLinks: languageLinks,
        activeLanguage: activeLanguage,
        mobileLinks: mobileLinks
      })))), /*#__PURE__*/_react.default.createElement(_MobileNav.ModalContainer, {
        role: "dialog",
        "aria-modal": "true",
        "aria-label": "Mobile Navigation",
        id: toggleButtonId,
        open: open
      }, jsEnabled && /*#__PURE__*/_react.default.createElement(_MobileNav.ModalContent, {
        "data-key": "".concat(dataKeyBase, "--mobile")
      }, mobileLinks.map(function (link, parentIndex) {
        if (!link.dropdown) {
          return /*#__PURE__*/_react.default.createElement(_MobileNav.NavItem, {
            onClick: _this2.handleModalControl,
            key: "mobile-nav-item-".concat(link.props.children).concat(parentIndex),
            "data-key": "".concat(dataKeyBase, "-").concat(parentIndex)
          }, link);
        } else {
          return /*#__PURE__*/_react.default.createElement("li", {
            key: "".concat(dataKeyBase, "-").concat(parentIndex, "--dropdown"),
            "data-key": "".concat(dataKeyBase, "-").concat(parentIndex, "--dropdown")
          }, /*#__PURE__*/_react.default.createElement(_MobileNav.StyledExpander, {
            icon: true,
            border: false,
            title: link.link.props.children
          }, /*#__PURE__*/_react.default.createElement(_MobileNav.MobileSubLinks, {
            "data-key": "".concat(dataKeyBase, "-").concat(parentIndex, "--sub-links")
          }, link.subLinks.map(function (subLink, subIndex) {
            return /*#__PURE__*/_react.default.createElement(_MobileNav.SubNavItem, {
              subLink: true,
              key: "sub-nav-item-".concat(parentIndex).concat(subIndex),
              "data-key": "".concat(dataKeyBase, "-").concat(parentIndex, "-sub-item-").concat(subIndex),
              onClick: _this2.handleModalControl
            }, subLink);
          }))));
        }
      }), mobileSecondaryLinks && /*#__PURE__*/_react.default.createElement(_MobileNav.SecondaryLinksWrapper, null, mobileSecondaryLinks.map(function (link, index) {
        return /*#__PURE__*/_react.default.createElement(_MobileNav.NavItem, {
          onClick: _this2.handleModalControl,
          key: "secondary-mobile-nav-item-".concat(index),
          "data-key": "secondary-".concat(dataKeyBase, "-").concat(index)
        }, link);
      })), languageLinks && languageLinks.length > 1 && /*#__PURE__*/_react.default.createElement(_LanguageDropDown.default, {
        languageLinks: languageLinks,
        activeLanguage: activeLanguage
      })))));
    }
  }]);
  return MobileNav;
}(_react.default.Component);
exports.MobileNav = MobileNav;
var _default = (0, _styledComponents.withTheme)(MobileNav);
exports.default = _default;